import { PROFILE_TYPES } from '@studio/constants/web-channels';
import { useCustomer } from '@studio/storeV2/customer/hooks/use-customer';
import { useRegions } from '@studio/storeV2/regions/hooks/use-regions';

const useQrClick = () => {
  const { webPlan } = useCustomer();
  const { regions: regionList } = useRegions();
  const isQrClickPlanSupported = Boolean(webPlan?.allowQrCodeDetection);
  const hasQrClickOverlaysPlan = Boolean(webPlan?.allowQrClickOverlays);

  function availableForRegion(regionId: string) {
    const selectedRegion = regionList.find((region) => region.uuid === regionId);
    return Boolean(selectedRegion?.hotspotsServiceUrl);
  }

  return {
    availableForCustomer: isQrClickPlanSupported,
    availableForRegion,
    availableForWebChannel(regionId: string, profileType?: string) {
      if (!profileType || profileType === PROFILE_TYPES.SOCIAL) {
        return false;
      }
      return isQrClickPlanSupported && availableForRegion(regionId);
    },
    qrClickOverlaysAvailable: hasQrClickOverlaysPlan && isQrClickPlanSupported,
  };
};
export default useQrClick;
